import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { Database } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

import { syncProviderTags } from "./syncProviderTags";

type ProviderUpdate = Database['public']['Tables']['providers']['Update'];
type Command = ProviderUpdate & {
  tag_ids?: string[];
};

async function updateProvider(providerId: string, command: Command) {
  const { tag_ids, ...providerData } = command;

  let data = null;
  if (Object.keys(providerData).length > 0) {
    const { data: updatedData, error } = await apiClient
      .from('providers')
      .update(providerData)
      .eq('id', providerId)
      .select()
      .single();

    if (error) {
      throw error;
    }
    data = updatedData;
  }

  if (tag_ids !== undefined) {
    await syncProviderTags(providerId, tag_ids);
  }

  return data;
}

type Variables = {
  providerId: string;
  command: Command;
}

export default function useUpdateProvider() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: ({ providerId, command }: Variables) => updateProvider(providerId, command),
    onSuccess: (_, { providerId }) => {
      queryClient.invalidateQueries({ queryKey: keys.getProviderById(providerId) });
      queryClient.invalidateQueries({ queryKey: keys.getProvidersList(currentSpace!.id) });
    },
  });
}
